module.exports = __webpack_public_path__ + "img/family.77e3f707.svg";